// @flow
import React, { useMemo } from 'react';
import moment from 'moment-timezone';

import styles from './DateFrom.module.scss';;


type Props = {
  date: string,
  timezone: string,
};

const DateFrom = ({ date, timezone }: Props) => {
  const dateString = useMemo(() => (date
    ? moment(date).tz(timezone).format(' от DD.MM.YYYY')
    : ''), [date, timezone]);

  return (
    <span className={styles.root}>
      {dateString}
    </span>
  );
};

export default DateFrom;
